enum SaleRuleType {
  GIFT = 1,
  ADDITION = 2,
  VIP_GIFT = 3,
  NORMAL = 0,
  UNKNOWN = 4,
}

export default SaleRuleType;
